// extracted by mini-css-extract-plugin
export default {"pageWrap":"vb-z","fullWidth":"wb-z","heading":"xb-z","fullBleed":"yb-z","hidden":"zb-z"};